import { ChangeDetectionStrategy, Component, computed, model } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzInputNumberModule } from 'ng-zorro-antd/input-number';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { FikoYTKokBilesenComponent } from '@/src/service/kok-bilesen/kok-bilesen.component';
import { CdkTextareaAutosize } from '@angular/cdk/text-field';

@Component({
  selector: 'cam-vardiya-edit',
  standalone: true,
  imports: [FormsModule, NzInputModule, NzInputNumberModule, NzSelectModule,
    CdkTextareaAutosize],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div class="se">
      <div class="se-baslik">
        <div class="se-baslik-ikon" style="background:linear-gradient(135deg,#d46b08,#fa8c16)">⏰</div>
        <span>Vardiya Kaydı</span>
      </div>
      <div class="se-form">
        <div class="form-grup">
          <label>Vardiya Türü <span class="zorunlu">*</span></label>
          <div class="input-wrap">
            <nz-select [ngModel]="p()?.vardiyaTuru" (ngModelChange)="guncelle('vardiyaTuru', $event)"
              nzPlaceHolder="Vardiya seçin..." style="width:100%">
              <nz-option nzValue="Sabah" nzLabel="Sabah" nzCustomContent>
                <span style="display:inline-flex;align-items:center;gap:6px"><span class="sel-dot" style="background:#faad14"></span> Sabah (06:00–14:00)</span>
              </nz-option>
              <nz-option nzValue="Öğle" nzLabel="Öğle" nzCustomContent>
                <span style="display:inline-flex;align-items:center;gap:6px"><span class="sel-dot" style="background:#fa8c16"></span> Öğle (14:00–22:00)</span>
              </nz-option>
              <nz-option nzValue="Gece" nzLabel="Gece" nzCustomContent>
                <span style="display:inline-flex;align-items:center;gap:6px"><span class="sel-dot" style="background:#722ed1"></span> Gece (22:00–06:00)</span>
              </nz-option>
            </nz-select>
            <div class="input-glow"></div>
          </div>
        </div>

        <div class="se-ayirici"></div>

        <div class="form-satir">
          <div class="form-grup" style="flex:1">
            <label>Üretim Adedi</label>
            <div class="input-wrap">
              <nz-input-number [ngModel]="p()?.uretimAdedi || null" (ngModelChange)="guncelle('uretimAdedi', $event)"
                [nzMin]="0" [nzStep]="1" nzPlaceHolder="Üretim" style="width:100%"></nz-input-number>
              <div class="input-glow"></div>
            </div>
          </div>
          <div class="form-grup" style="flex:1">
            <label>Red Adedi</label>
            <div class="input-wrap">
              <nz-input-number [ngModel]="p()?.redAdedi || null" (ngModelChange)="guncelle('redAdedi', $event)"
                [nzMin]="0" [nzStep]="1" nzPlaceHolder="Red" style="width:100%"></nz-input-number>
              <div class="input-glow"></div>
            </div>
          </div>
        </div>
        @if (verimlilik() !== null) {
          <div style="padding:6px 12px;border-radius:8px;margin-top:4px;display:flex;align-items:center;gap:8px"
            [style.background]="verimlilik()! >= 90 ? 'rgba(82,196,26,.08)' : verimlilik()! >= 70 ? 'rgba(250,173,20,.08)' : 'rgba(255,77,79,.08)'">
            <span style="font-size:11px;color:var(--py-metin-ucuncul)">Verimlilik:</span>
            <span style="font-size:14px;font-weight:700"
              [style.color]="verimlilik()! >= 90 ? '#52c41a' : verimlilik()! >= 70 ? '#d48806' : '#ff4d4f'">%{{ verimlilik() }}</span>
          </div>
        }

        <div class="se-ayirici"></div>

        <div class="form-grup">
          <label>Operatör</label>
          <div class="input-wrap">
            <input nz-input autocomplete="off"
              [ngModel]="p()?.operator || ''" (ngModelChange)="guncelle('operator', $event)"
              placeholder="Operatör adı..."/>
            <div class="input-glow"></div>
          </div>
        </div>

        <div class="se-ayirici"></div>

        <div class="form-grup">
          <label>Devir Notları</label>
          <div class="input-wrap">
            <textarea nz-input autocomplete="off"
              [ngModel]="p()?.devirNotlari || ''" (ngModelChange)="guncelle('devirNotlari', $event)"
              placeholder="Vardiya devir notları..." cdkTextareaAutosize [cdkAutosizeMinRows]="2" [cdkAutosizeMaxRows]="4"></textarea>
            <div class="input-glow"></div>
          </div>
        </div>
      </div>
    </div>
  `,
  styleUrl: './cam-edit.styles.less',
})
export class CamVardiyaEditComponent extends FikoYTKokBilesenComponent {
  parametreler = model<any>();
  constructor() { super(); }

  p = computed(() => this.parametreler()?.ek || {});

  guncelle(alan: string, deger: any) {
    const params = this.parametreler();
    if (params?.ek) { params.ek[alan] = deger; this.parametreler.set({ ...params }); }
  }

  verimlilik = computed(() => {
    const uretim = +(this.p()?.uretimAdedi || 0);
    const red = +(this.p()?.redAdedi || 0);
    if (!uretim) return null;
    return Math.round(((uretim - red) / uretim) * 100);
  });
}
